import $http from '@/api/http'
import * as qs from 'qs'

interface State {
  fukens: { [key: string]: { [val: number]: string } }
  jobs: { [key: number]: string }
  types: { [key: number]: string }
  charms: { [key: number]: string }
  shutubotus: { [key: number]: string }
}

const defaultState: State = {
  fukens: {},
  jobs: {},
  types: {},
  charms: {},
  shutubotus: {}
}

const state: State = Object.assign({}, defaultState)

const mutations = {
  resetState(state: State) {
    const s = defaultState
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },
  setFukens: (state: State, payload: { key: string; datas: Array<string> }) => {
    state.fukens = payload
  },
  setJobs(state: State, jobs: {}) {
    state.jobs = jobs
  },
  setTypes(state: State, types: {}) {
    state.types = types
  },
  setCharms(state: State, charms: {}) {
    state.charms = charms
  },
  setShutubotus(state: State, shutubotus: {}) {
    state.shutubotus = shutubotus
  },
  setProfileItems: (state: State, payload: { [key: string]: { [key: number]: string } }) => {
    state.fukens = payload.fuken
    state.charms = payload.charm
    state.jobs = payload.job
    state.types = payload.type
    state.shutubotus = payload.shutubotu
  }
}

const actions = {
  async getFukens({ commit }) {
    try {
      const res = await $http.get('/regist.php?page=get_area_fuken')
      if (res.data.error) {
        throw new Error(res.data.error)
      }
      delete res.data.result
      commit('setFukens', res.data)
    } catch (err) {
      console.error(err)
    }
  },

  async getProfileItems({ commit }) {
    try {
      const res = await $http.post(
        '/profile_setting/',
        qs.stringify({
          page: 'get_init'
        })
      )
      if (res.data.error) {
        throw new Error(res.data.error)
      }
      commit('setProfileItems', res.data.list_data)
    } catch (err) {
      console.error(err)
    }
  }
}

const getters = {
  /**
   * 全ての項目がからでなければ初期化済み
   */
  initializedProfile: (state: State): boolean => {
    if (
      state.fukens &&
      Object.keys(state.fukens).length > 0 &&
      state.charms &&
      Object.keys(state.charms).length > 0 &&
      state.jobs &&
      Object.keys(state.jobs).length > 0 &&
      state.shutubotus &&
      Object.keys(state.shutubotus).length > 0 &&
      state.types &&
      Object.keys(state.types).length > 0
    ) {
      return true
    } else {
      return false
    }
  },
  fukens: (state: State): { [key: string]: { [val: number]: string } } => state.fukens,
  fukenGroups: (state: State): string[] => Object.keys(state.fukens),
  /**
   * 大都市を返す
   */
  bigCities: (state: State): { [key: string]: { [val: number]: string } } => {
    if (
      Object.keys(state.fukens).length === 0 ||
      (state.fukens.message && state.fukens.message['length']) > 0
    ) {
      return {}
    }
    const cities: { [key: string]: { [val: number]: string } } = {}
    const extractKeys = {
      関東: '東京都',
      東海: '愛知',
      関西: '大阪',
      '九州・沖縄': '福岡'
    }
    for (const key of Object.keys(extractKeys)) {
      const val = extractKeys[key]
      for (const cityNo of Object.keys(state.fukens[key])) {
        // if (typeof cityNo !== 'string') { continue }
        if (state.fukens[key][cityNo] === val) {
          cities[cityNo] = val
        }
      }
    }
    return cities
  },
  jobs: (state: State): { [key: number]: string } => state.jobs,
  types: (state: State): { [key: number]: string } => state.types,
  charms: (state: State): { [key: number]: string } => state.charms,
  shutubotus: (state: State): { [key: number]: string } => state.shutubotus
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
